import { useQuery, UseQueryResult } from "@tanstack/react-query";
import axios from "../../utils/axiosinstance";

import { enum_api_uri } from "common/hooks/utils/enum";
import { useAuthStore } from "user/store/useAuthStore";

interface Response {
    product_idx: number;
    product_name: string;
    product_amount: number;
    product_image: [
        {
            file_idx: number;
            file_name: string;
            original_name: string;
        },
    ];
    notice_image: [
        {
            file_idx: number;
            file_name: string;
            original_name: string;
        },
    ];
    product_category: {
        product_category_idx: number;
        category_name: string;
        union_option: boolean;
        wreath_option: boolean;
    };
    product_content: string;
    product_memo: string;
}

export const useGetProductInfo = (product_idx: number): UseQueryResult<Response, Error> => {
    const accessToken = useAuthStore(state => state.accessToken);
    return useQuery<Response, Error>({
        queryKey: ["getProductInfo", product_idx],
        queryFn: async () => {
            const response = await axios.get(`${enum_api_uri.user.get_product_info.replace(":product_idx", product_idx.toString())}`, {
                headers: {
                    Authorization: `Bearer ${accessToken}`,
                },
            });
            return response.data.data;
        },
        enabled: !!product_idx,
        // placeholderData: prevData => {
        //     if (prevData) {
        //         return {
        //             ...prevData,
        //         };
        //     }
        //     return undefined;
        // },
    });
};
